<!-- Hero Section -->
<section class="hero-section">
    <div class="page-title-area">
        <div class="container">
            <div class="hero-content">
                <img src="assets/images/macmini/mini.png" alt="Mac Mini" class="hero-image">
                <p class="gradient-text">Built for Apple Intelligence</p>
            </div>
        </div>
    </div>
</section>

<!-- <div class="mac-mini-container">
    <h1><span class="mac-text">Mac</span> <span class="mini-text">mini</span></h1>
  
    <div class="mac-mini-image">
      <img src="assets/images/macmini/mini.png" alt="Mac Mini" />
    </div>
  
    <p class="subtitle">
      Built for <span class="gradient-text">Apple Intelligence.</span>
    </p>
  
  </div> -->
  

  <div class="design-section">
    <p class="section-title">Design</p>
    <h1 class="headline">
      Looks small. <span class="highlight">Lives large.</span>
    </h1>
    <p class="description">
      Introducing the far mightier, way tinier, all-new Mac mini. Five by five inches of pure power and purpose.
      Redesigned around Apple silicon to unleash the full speed and capabilities of M4 and M4 Pro chips.
      With a wide array of ports, now on the front and back. Mac mini is the definition of efficiency — and the
      first carbon neutral Mac. It truly is the little Mac that could.
    </p>
  
    <div class="image-row">
      <div class="dimension vertical">5"</div>
      <img src="assets/images/macmini/macmini1.png" alt="Mac Mini Top" class="mac-mini-image" />
    
    </div>
    <div class="dimension horizontal">5"</div>
    <div class="stats">
    
        <strong class="ratio">1/20</strong> the size<br />
      yet up to <strong class="highlight-blue">6x</strong> faster
      <p class="note">compared with the top-selling PC desktop in its price range.<sup>3</sup></p>
     
    </div>
  
    <div class="ports-section">
      <div class="port">
        <p class="port-label">
          2x USB‑C<br />
          Headphone jack
        </p>
        <img src="assets/images/macmini/ports-c.png" alt="Mac Mini Front Ports" class="port-image" />
        <p class="port-caption">Front ports</p>
      </div>
  
      <div class="port">
        <p class="port-label">
          HDMI<br />
          Ethernet<br />
          3x Thunderbolt
        </p>
        <img src="assets/images/macmini/ports.png" alt="Mac Mini Back Ports" class="port-image" />
        <p class="port-caption">Back ports</p>
      </div>
    </div>
  </div>
  

  <div class="cooling-container">
    <div class="text-content">
      <h2 class="title">
        Built to <span class="highlight">chill.</span>
      </h2>
      <p class="description">
        Putting this much power in such a small space took a whole new thermal architecture.
        Within Mac mini, air is guided to different levels of the system, and all of it flows through the foot.
        Combined with Apple silicon's unmatched power efficiency, this allows Mac mini to breeze through
        intensive workloads at outrageous speeds. It's calm, cool, and perfected.
      </p>
    </div>
  
    <div class="image-wrapper">
      <img src="assets/images/macmini/built.png" alt="Mac Mini Cooling" class="cooling-image" />
    </div>
  </div>
  

  <div class="performance-container">
    <div class="intro">
      <p class="section-label">Performance</p>
      <h2 class="headline">M4 and M4 Pro. <span class="highlight">Champion chips.</span></h2>
    </div>
  
    <div class="triple-display">
      <img src="assets/images/macmini/display.png" alt="Mac mini with three displays" />
      <p class="caption">Create 4K with Autodesk, DaVinci Resolve Studio</p>
    </div>
  
    <div class="description">
      <p>
        Now with M4 and M4 Pro, Mac mini delivers tremendous performance and next-level AI capabilities.
        Both chips feature the world's fastest CPU core, so everything feels snappy and fluid. Thanks to
        a powerful GPU with hardware-accelerated ray tracing, you'll experience incredibly lifelike
        games and graphics with smooth 3D rendering. And an advanced Neural Engine runs on-device
        Apple Intelligence at blazing speed.
      </p>
    </div>
  
    <div class="feature-cards">
      <div class="card" style="border: 0;"><strong>Hardware-accelerated</strong><br />ray tracing for game-changing graphics.</div>
      <div class="card" style="border: 0;"><strong>Drives up to</strong><br />three displays.</div>
      <div class="card" style="border: 0;"><strong>World's fastest</strong><br />CPU core for incredible responsiveness.</div>
    </div>
  
    <div class="productivity-grid">
      <img src="assets/images/macmini/setup.png" alt="Mac mini setup" class="grid-img" />
      <!-- <img src="assets/productivity-ui.png" alt="UI view" class="grid-img" /> -->
    </div>
  
    <!-- <div class="productivity-tags">
      <span class="tag active">Productivity</span>
      <span class="tag">Creativity</span>
      <span class="tag">STEM</span>
      <span class="tag">Gaming</span>
      <span class="tag">Coding</span>
    </div>
  
    <div class="productivity-text">
      <p>
        Make short work of everyday tasks, open and switch between apps seamlessly, and collaborate
        across apps like Adobe Acrobat, Microsoft Excel, Slack, and Zoom. And with Apple Intelligence,
        you have all kinds of features to supercharge productivity.
      </p>
      <button class="cta-button">Check out M4 and M4 Pro</button>
    </div> -->
  </div>
  
  <div class="mac-mini-setup-container" style="margin-top: 100px; width: 100%;height: 100%;">
    <img src="assets/images/macmini/macminisetup1.jpg" alt="Mac Mini"  />
  </div>